var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{},attrs:{"id":"login","fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs10":"","md6":"","lg4":""}},[_c('v-card',[_c('v-container',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }